import React from "react";

interface FormattedDateProps {
  date: string | Date;
}

export const FormattedDate: React.FC<FormattedDateProps> = ({ date }) => {
  const parsedDate = React.useMemo(() => {
    if (!date) return null;

    if (date instanceof Date) return date;

    let normalized = date;
    if (typeof date === "string" && date.includes(" ") && !date.includes("T")) {
      normalized = date.replace(" ", "T");
    }

    const d = new Date(normalized);
    return isNaN(d.getTime()) ? null : d;
  }, [date]);

  if (!parsedDate) return <>Invalid Date</>;

  // Format like: July 30, 2025
  const formatted = parsedDate.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return <>{formatted}</>;
};
